import _ from 'lodash'
import enabled from '../../helpers/enabled'
import values from '../../helpers/values'

export default (form, year) => (
  _.sum(
    values(
      _.filter(enabled(form, 'monthlyCosts'), ({ startingAge, endingAge }) => (
        _.inRange(year, startingAge, endingAge)
      ))
    )
  ) * 12
)
